/*
 * @Author: lqb
 * @Date: 2025-04-14 16:31:48
 * @LastEditors: lqb
 * @LastEditTime: 2025-04-22 16:11:22
 * @Description: file content
 */

import axios from "@/libs/api.request";

const Api = {};

/**
 * @description 线索列表
 */
Api.findPageISO = (opts) =>
  axios.request({
    url: "/crm/clue/page",
    method: "get",
    data: { ...opts, transformStatus: false },
  });

/**
 * @description 客户管理
 */
Api.getCustomerList = (opts) =>
  axios.request({
    url: "/crm/customer/page",
    method: "get",
    data: { ...opts, sceneType: 1 },
  });

/**
 * @description 查询所有正常状态的业务员
 */
Api.findNormalList = (opts) =>
  axios.request({
    url: "/api/app/outsource/operator/normal/list",
    data: opts,
  });

/**
 * @description 忘记密码
 * @param {string} mobile 手机号
 * @param {string} password 用户密码
 * @param {string} smsCode 短信验证码
 */
Api.forgetPwd = (opts) =>
  axios.request({
    url: "/system/user/forget-password",
    data: opts,
  });

/**
 * @description 退出登录
 */
Api.logout = () =>
  axios.request({
    url: "/system/auth/logout",
  });

/**
 * @description 无感刷新token
 */
Api.refreshToken = (refreshtoken) => {
  if (!refreshtoken) return;
  return axios.request({
    url: `/system/auth/refresh-token?refreshToken=${refreshtoken}`,
  });
};

/**
 * @description 注册账号
 */
Api.register = (data) =>
  axios.request({
    url: "/system/user/h5/create",
    data,
  });

/**
 * @description 密码登录
 * @param {string} username 用户名
 * @param {string} password 密码
 * @param {string} tenantName 机构名称
 */
Api.login = (opts) =>
  axios.request({
    url: "/system/auth/login",
    data: opts,
    headers: {
      isToken: false,
    },
  });

/**
 * @description 发送短信验证码
 * @param {string} mobile 手机号
 * @param {string} smsCodeType 机构编号 <LOGIN, FORGET_PWD>
 */
Api.smsLgcode = (phone) =>
  axios.request({
    url: `/system/sms-template/ym/send/${phone}`,
    method: "GET",
  });

/**
 * @description 上传
 * @param {string} xxx xxx
 */
Api.uploadFile = (opts) =>
  axios.request({
    url: "/infra/file/upload",
    data: opts,
  });

/**
 * @description 获取用户基本信息
 * @param {Object} opts
 * @param {Boolean} refresh 是否重新请求
 */

Api.baseInfo = () => {
  return axios
    .request({
      url: "/system/auth/get-permission-info",
      method: "GET",
    })
    .then((res) => {
      let user = res?.data?.user ?? {};
      localStorage.setItem("userAccount", JSON.stringify(user));
      return user;
    });
};

/**
 * @description 跟进日历
 */
Api.skyCalendarStatistics = (data = {}) =>
  axios.request({
    url: `/crm/customer/date/count`,
    method: "GET",
    data,
  });

/**
 * @description 新增线索/修改线索-新增客户/修改客户
 */
Api.operatorRegister = (data = {}) => {
  let url = data.isUser ? "customer" : "clue";
  if (data.id)
    return axios.request({
      url: `/crm/${url}/update`,
      data,
      method: "PUT",
    });
  return axios.request({
    url: `/crm/${url}/create`,
    data,
  });
};

/**
 * @description 线索详情
 */
Api.findDetailById = (data = {}) => {
  let url = data.isUser ? "customer" : "clue";
  return axios.request({
    url: `/crm/${url}/get`,
    method: "GET",
    data,
  });
};

/**
 * @description 创建跟进
 */
Api.createFollow = (data = {}) =>
  axios.request({
    url: `/crm/follow-up-record/create`,
    data,
  });

/**
 * @description 跟进列表
 */
Api.getFollowList = (data = {}) =>
  axios.request({
    url: `/crm/follow-up-record/page`,
    method: "GET",
    data,
  });

/**
 * @description 跟进联系人
 */
Api.getContactsList = (data = {}) =>
  axios.request({
    url: `/crm/contact/page-by-customer`,
    method: "GET",
    data,
  });

/**
 * @description 新增联系人
 */
Api.createContact = (data = {}) =>
  axios.request({
    url: `/crm/contact/${data.id ? "update" : "create"}`,
    method: data.id ? "PUT" : "POST",
    data,
  });

/**
 * @description 获取联系人
 */
Api.getContact = (data = {}) =>
  axios.request({
    url: `/crm/contact/get`,
    method: "GET",
    data,
  });
/**
 * @description 线索转化为客户
 * @param {string} id 线索id
 */
Api.clueTurnIntoCustomers = (id) =>
  axios.request({
    url: `/crm/clue/transform?id=${id}`,
    method: "PUT",
  });

/**
 * @description 更新客户的成交状态
 * @param {Object} data
 * @param {string} data.id 客户id
 * @param {string} data.dealStatus 成交状态
 */
Api.updateCustomerStatus = (url) =>
  axios.request({
    url: `/crm/customer/update-deal-status?${url}`,
    method: "PUT",
  });

/**
 * @description 用户密码重置
 * @param {Object} data
 * @param {string} data.oldPassword 旧密码
 * @param {string} data.newPassword 新密码
 */
Api.updateUserPassword = (data) =>
  axios.request({
    url: `/system/user/profile/update-password`,
    method: "PUT",
    data,
  });

/**
 * @description 找回密码
 * @param {Object} data
 * @param {string} data.newPassword 旧密码
 * @param {string} data.newPassword 新密码
 * @param {string} data.smsCode 短信验证码
 * @param {string} data.mobile 手机号
 */
Api.findUserPassword = (data) =>
  axios.request({
    url: `/system/user/profile/update-password/by/sms`,
    method: "PUT",
    data,
  });

/**
 * @description 地址列表
 */
Api.areaList = () =>
  axios.request({
    url: `/system/area/tree`,
    method: "GET",
  });

export default Api;
